// Generated by Claude Code
import { WorkOrderTemplateDetailPanel } from '#components/domain/operations/work-orders/work-order-templates/work-order-template-detail-panel.tsx'
import { WorkOrderTemplateUpsertDrawer } from '#components/domain/operations/work-orders/work-order-templates/work-order-template-upsert-drawer.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionAction, PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_app/$companyId/work-order-templates/$templateId')({
  component: RouteComponent,
  staticData: {
    title: 'Work Order Template Detail',
  },
})

function RouteComponent() {
  return (
    <PermissionGuard
      permissions={[[[PermissionService.WORK_ORDER_TEMPLATES, PermissionAction.READ]]]}
      redirectOnNotAuthorized
    >
      <WorkOrderTemplateDetailPageContent />
    </PermissionGuard>
  )
}

function WorkOrderTemplateDetailPageContent() {
  const { companyId, templateId } = Route.useParams()
  const navigate = useNavigate()
  const { t } = useTranslation('work-orders')

  const [editOpen, setEditOpen] = useState(false)
  // The panel has no reloadKey; bump this key to remount (and refetch) after an edit.
  const [reloadKey, setReloadKey] = useState(0)

  function handleBack() {
    void navigate({ to: '/$companyId/work-order-templates', params: { companyId } })
  }

  return (
    <div className="container-fluid d-flex flex-column h-100 py-3">
      <div className="row justify-content-center flex-grow-1">
        <div className="col-12 col-lg-10 col-xl-8 d-flex flex-column">
          <div className="mb-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
              onClick={handleBack}
            >
              <ArrowLeft size={14} />
              {t('shared.actions.backToList')}
            </button>
          </div>
          <div className="flex-grow-1 overflow-hidden card rounded-3 p-0">
            <WorkOrderTemplateDetailPanel
              key={reloadKey}
              templateId={templateId}
              onClose={handleBack}
              onEdit={() => setEditOpen(true)}
            />
          </div>
        </div>
      </div>

      <WorkOrderTemplateUpsertDrawer
        mode="edit"
        isOpen={editOpen}
        workOrderTemplateId={templateId}
        onClose={() => setEditOpen(false)}
        onUpdated={() => { setEditOpen(false); setReloadKey((k) => k + 1) }}
      />
    </div>
  )
}
